import React, {Fragment} from 'react';
import {ScrollTopBtn, Seo} from '../components';
import {
    AboutOne,
    BlogTwo,
    BrandOne, CareerSingle, ContactOne,
    CtaOne,
    FaqOne,
    FeatureOne,
    FooterOne, HeaderOneCopy,
    HeroOne,
    ProcessOne,
    ServiceOne,
    TestimonialOne,
} from '../containers';
import CareerDetails from "./CareerDetails";
import AboutTwoEInvoiceSection from "../containers/Abouts/AboutTwoEInvoiceSection";

const HomeOne = () => (
    <Fragment>
        <Seo title="eSyncross"/>
        <HeaderOneCopy/>
        <HeroOne/>
        <div className="background-image" style={{backgroundImage: "url(images/bg/ab-bg-1-1.jpg)"}}>
            <FeatureOne className="space-top space-extra-bottom"/>
            <AboutTwoEInvoiceSection className="space-extra-bottom"/>
        </div>
        <AboutOne className="space-bottom space-top "/>
        <ServiceOne className="space-top space-extra-bottom services-offering"/>
        <CtaOne className="space"/>
        <ProcessOne className="space-top space-extra-bottom"/>
        <FaqOne className={"why-choose-us"}/>
        <TestimonialOne className="space-top space-extra-bottom customers-feedback"/>
        <BrandOne className="space-bottom"/>
        <ContactOne/>
        <BlogTwo className="space-top space-extra-bottom latest-articles"/>
        <FooterOne/>
        <ScrollTopBtn/>
    </Fragment>
);

export default HomeOne;